import { EMPTY, from, Observable, ObservableInput, ObservedValueOf, of, OperatorFunction, throwError } from 'rxjs';
import { catchError, retryWhen, switchMap } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { getErrorSwal, showErrorSwal } from '../validation-helpers/show-error-swal';

export function catchErrorSwal<T>(options: { retry?: boolean } = null): OperatorFunction<T, T> {
	if (options?.retry === true) {
		return retryWhen(errors =>
			errors.pipe(
				switchMap(error => {
					const swalOptions = getErrorSwal(error);
					swalOptions.confirmButtonText = `Try again`;
					swalOptions.cancelButtonText = `Cancel`;
					swalOptions.showCancelButton = true;
					swalOptions.allowOutsideClick = false;
					swalOptions.allowEscapeKey = false;

					return from(Swal.fire(swalOptions)).pipe(
						switchMap(swalResult => (!!swalResult.isConfirmed ? of(true) : throwError(new RetryCancelledError())))
					);
				})
			)
		);
	} else {
		return catchError(error => {
			showErrorSwal(error);
			return EMPTY;
		});
	}
}

export function catchRetryError<T, O extends ObservableInput<any>>(
	selector: (err: any, caught: Observable<T>) => O
): OperatorFunction<T, T | ObservedValueOf<O>> {
	return catchError((error, caught) => {
		if (error instanceof RetryCancelledError) {
			return selector(error, caught);
		} else {
			return throwError(error);
		}
	});
}

export class RetryCancelledError implements Error {
	name: string;
	message: string;
	stack?: string;

	constructor() {
		Error.call(this);
		this.stack = new Error().stack;
		this.message = 'Retry was cancelled';
		this.name = 'RetryCancelledError';
	}
}
